module.exports = __webpack_public_path__ + "static/media/sign-in.d3e07719.mov";